/**
 * CTM webhook payloads include `tracking_label` (e.g. pool / source name in CTM).
 * We persist the full payload on call_logs.metadata.
 */
export function getCtmTrackingLabel(metadata: unknown): string | null {
  if (!metadata || typeof metadata !== 'object') return null;
  const label = (metadata as Record<string, unknown>).tracking_label;
  if (typeof label === 'string' && label.trim()) return label.trim();
  return null;
}
